// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__NOX5M","content":"Contact_content__gid8P"};